// Sine waves across the surface
vec3 displace(vec3 pos, vec2 uv, inout float elevation)
{
    float t = uTime * uSpeed;
    vec2 p = (uv - 0.5) * 2.0;  // uv-based so it works on any shape
    elevation = sin(p.x * uFrequency + t) * sin(p.y * uFrequency * 0.7 + t * 0.8);
    pos += normal * elevation * uStrength;
    return pos;
}
